module.exports = __webpack_public_path__ + "img/img-colax-esports.76c518f9.png";